import { createRequestTypes } from '@alycecom/utils';

export const INTEGRATIONS_MARKETO = createRequestTypes('INTEGRATIONS_MARKETO');
export const INTEGRATIONS_MARKETO_ITEM = createRequestTypes('INTEGRATIONS_MARKETO_ITEM');
export const INTEGRATIONS_MARKETO_CREATE = createRequestTypes('INTEGRATIONS_MARKETO_CREATE');
export const INTEGRATIONS_MARKETO_UPDATE = createRequestTypes('INTEGRATIONS_MARKETO_UPDATE');
export const INTEGRATIONS_MARKETO_DISCONNECT = createRequestTypes('INTEGRATIONS_MARKETO_DISCONNECT');
export const INTEGRATIONS_MARKETO_ACTIVITIES_SYNC = createRequestTypes('INTEGRATIONS_MARKETO_ACTIVITIES_SYNC');
export const INTEGRATIONS_MARKETO_ACTIVITIES_SYNC_STATUS = createRequestTypes(
  'INTEGRATIONS_MARKETO_ACTIVITIES_SYNC_STATUS',
);
export const INTEGRATIONS_MARKETO_ACTIVITIES_AVAILABLE = createRequestTypes(
  'INTEGRATIONS_MARKETO_ACTIVITIES_AVAILABLE',
);
export const INTEGRATIONS_MARKETO_ACTIVITIES_ENABLED = createRequestTypes('INTEGRATIONS_MARKETO_ACTIVITIES_ENABLED');

export const INTEGRATIONS_MARKETO_WEBHOOKS = createRequestTypes('INTEGRATIONS_MARKETO_WEBHOOK');

export const INTEGRATIONS_MARKETO_ALYCE_GIFT_OBJECT = createRequestTypes('INTEGRATIONS_MARKETO_ALYCE_GIFT_OBJECT');

export const INTEGRATIONS_MARKETO_CUSTOM_OBJECTS_SYNC = createRequestTypes('INTEGRATIONS_MARKETO_CUSTOM_OBJECTS_SYNC');

export const INTEGRATIONS_MARKETO_SET_CUSTOM_OBJECT_STATE = createRequestTypes(
  'INTEGRATIONS_MARKETO_SET_CUSTOM_OBJECT_STATE',
);

export const INTEGRATIONS_MARKETO_CUSTOM_OBJECT_SYNC_BY_UUID = createRequestTypes(
  'INTEGRATIONS_MARKETO_CUSTOM_OBJECT_SYNC_BY_UUID',
);
